function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "16.02",
  viewBox: "0 0 15 16.02",
  stroke: "currentcolor",
  fill: "currentcolor",
  strokeWidth: "0",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M15 .5V.49A.49.49 0 0014.5 0H5.63L0 5.64v9.89a.49.49 0 00.49.49H14.5a.49.49 0 00.48-.39v-.1V.5zm-4.35 1.28h2.57v4.4L9.98 2.93l.67-1.15zM5.64 6.12a.49.49 0 00.48-.49V1.78h3.5l-4.85 8.4-3-2.98V6.12h3.87zm-3.86 8.12V8.45l2.53 2.53-1.88 3.24h-.65zm1.68 0l6.06-10.5 3.7 3.7v6.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.65 7.22a2.15 2.15 0 00-1.73 3.42l1.38 2.4a.36.36 0 00.03.05.39.39 0 00.61.02l.01-.02a.4.4 0 00.06-.1l1.36-2.35a2.15 2.15 0 00-1.73-3.43zm-.02 3.24a1.06 1.06 0 111.06-1.06 1.06 1.06 0 01-1.06 1.06z"
}))));